module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.isLoading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      " + _vm._s(_vm.type === 'transaction' ? 'Transaction Notices' : 'Documents') + "\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "table-responsive top-margin table-fixed-header--md desktop-table"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left"
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "text-right with-right-padding"
  }, [_vm._v(_vm._s(_vm.type === 'transaction' ? 'Sent on' : 'Uploaded on'))])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.documents), function(document) {
    return _c('tr', {
      key: document.Key
    }, [_c('td', {
      staticClass: "file file-name td-blocked",
      on: {
        "click": function($event) {
          _vm.openDocument(document)
        }
      }
    }, [_c('i', {
      staticClass: "icon fa fa-file-text-o"
    }), _c('a', [_vm._v(_vm._s(document.Key))])]), _vm._v(" "), _c('td', {
      staticClass: "file-updated-date text-right with-right-padding td-blocked"
    }, [_vm._v(_vm._s(_vm.formatDate(!!document.Head &&
      !!document.Head.Metadata &&
      !!document.Head.Metadata.uploaded_at ?
      document.Head.Metadata.uploaded_at : document.LastModified)))])])
  }), _vm._v(" "), (!_vm.documents.length) ? _c('tr', {
    staticClass: "align-center"
  }, [_c('td', {
    staticClass: "file file-name td-blocked"
  }, [_vm._v("No Documents to display")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "mobile-card-view"
  }, [(_vm.documents.length) ? _c('div', {
    staticClass: "document-cards"
  }, _vm._l((_vm.documents), function(document) {
    return _c('div', {
      key: document.Key,
      staticClass: "document-card",
      on: {
        "click": function($event) {
          _vm.openDocument(document)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "document-card-content"
    }, [_c('div', {
      staticClass: "document-card-name"
    }, [_vm._v(_vm._s(document.Key))]), _vm._v(" "), _c('div', {
      staticClass: "document-card-date"
    }, [_vm._v("\n                 " + _vm._s(_vm.type === 'transaction' ? 'Sent on' : 'Uploaded on') + ": \n                 " + _vm._s(_vm.formatDate(!!document.Head &&
      !!document.Head.Metadata &&
      !!document.Head.Metadata.uploaded_at ?
      document.Head.Metadata.uploaded_at : document.LastModified)) + "\n               ")])]), _vm._v(" "), _vm._m(1, true)])
  })) : _c('div', {
    staticClass: "no-documents-mobile"
  }, [_c('i', {
    staticClass: "fa fa-folder-open-o"
  }), _vm._v(" "), _c('p', [_vm._v("No Documents to display")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-card-icon"
  }, [_c('i', {
    staticClass: "icon fa fa-file-text-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-card-arrow"
  }, [_c('i', {
    staticClass: "fa fa-chevron-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-234f5326","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AccountDocuments.vue
// module id = 2118
// module chunks = 1